module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page manage-page px-5"
  }, [_c('upload-nav', {
    attrs: {
      "name": "manage"
    }
  }), _vm._v(" "), _c('content-top-header', {
    staticClass: "content-top-header-tab"
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', _vm._l((_vm.tabFilterOptions), function(filter) {
    return _c('li', {
      key: filter.id,
      class: {
        'active tab-active': _vm.isActiveFilter(filter.value)
      },
      attrs: {
        "href": ("#" + (filter.value))
      }
    }, [_c('label', {
      staticClass: "innerBold",
      on: {
        "click": function($event) {
          _vm.setActiveInnerFilter(filter.value)
        }
      }
    }, [_vm._v(_vm._s(filter.title))])])
  }))])], 2), _vm._v(" "), (_vm.activeInnerFilter != 'videos') ? _c('content-top-header', {
    staticClass: "manage-tab-content content-top-header-tab"
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', _vm._l((_vm.getInnerMenuTabs(_vm.activeInnerFilter)), function(tab) {
    return _c('li', {
      key: tab.id,
      class: {
        active: _vm.isActiveInnerTab(tab.id)
      },
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      on: {
        "click": function($event) {
          _vm.setInnerTab(tab.id)
        }
      }
    }, [_vm._v(_vm._s(tab.title))])])
  }))])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active_tab === 'content'),
      expression: "active_tab === 'content'"
    }],
    class: _vm.activeInnerFilter != 'videos' ? 'mt-180' : 'mt-130'
  }, [_c('manage-album', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeInnerFilter === 'albums'),
      expression: "activeInnerFilter === 'albums'"
    }],
    ref: "manageAlbum",
    attrs: {
      "textBtnToRight": _vm.activeInnerFilter == 'albums' &&
        (_vm.activeInnerTab == 'published' || _vm.activeInnerTab == 'privated')
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08127653","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/manage/index.vue
// module id = 1601
// module chunks = 180